var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    this.$store.getters.application.applicationCode.indexOf("ipsystur") != -1
      ? _c(
          "div",
          { staticStyle: { "margin-bottom": "10px", height: "12px" } },
          [
            _c(
              "span",
              {
                staticStyle: {
                  color: "blue",
                  "font-size": "20px",
                  height: "10px"
                }
              },
              [_vm._v(_vm._s(this.$store.getters.language["ipsys.turProtect"]))]
            )
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "copyright" }, [
      _c("span", [_vm._v(_vm._s(_vm.language["common.footer.one"]))])
    ]),
    _c(
      "div",
      { staticClass: "copyright" },
      [
        _vm._v("\n      Copyright\n      "),
        _c("a-icon", { attrs: { type: "copyright" } }),
        _vm._v("\n      " + _vm._s(_vm.language["common.copyright.year"])),
        _c("span", [_vm._v(_vm._s(_vm.language["portal.ui2.copyright"]))]),
        _c(
          "a",
          {
            staticStyle: { "padding-left": "5px" },
            attrs: {
              target: "_blank",
              href: "https://beian.miit.gov.cn/#/Integrated/recordQuery"
            }
          },
          [_vm._v(_vm._s(_vm.language["common.copyright.filingweb"]))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }